<template>
  <div class="layout-configuracoes">
    <main class="conteudo-principal">
      <router-view />
    </main>
  </div>
</template>

<script setup></script>

<style scoped>
.layout-configuracoes {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.conteudo-principal {
  flex: 1 1 auto;
  overflow-y: auto;
  background-color: var(--color-bg);
  padding: var(--space-8);
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.conteudo-principal > * {
  width: 100%;
  max-width: 900px;
}

@media (max-width: 768px) {
  .conteudo-principal {
    padding: var(--space-4);
    align-items: stretch;
  }
}
</style>
